// The claim token is a bearer credential: whoever presents it takes ownership of a
// provider listing. It arrives in the URL *fragment* (#claim=...), never a query
// parameter -- a fragment is not sent to the server, so it cannot land in an nginx
// access log. It is moved into sessionStorage and stripped from the URL immediately so
// it never reaches browser history either.
const STORAGE_KEY = 'anipaw.claimToken';

export function captureClaimToken() {
  const hash = window.location.hash || '';
  const match = hash.match(/[#&]claim=([^&]+)/);
  // No token in this URL: leave any previously captured one alone. The user may have
  // landed on /signup with the link and then navigated to /login.
  if (!match) return readClaimToken();

  const token = decodeURIComponent(match[1]);
  sessionStorage.setItem(STORAGE_KEY, token);

  // Strip it before it is committed to history. Both signup handlers navigate away
  // immediately, so this has to happen on mount, not after authentication returns.
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname + window.location.search
  );
  return token;
}

export function readClaimToken() {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function clearClaimToken() {
  sessionStorage.removeItem(STORAGE_KEY);
}

/**
 * Whether to keep the stored token after a failed claim.
 *
 * Terminality is declared by the server, never inferred from HTTP status: two terminal
 * outcomes are 409s, which a status-based client would treat as retryable and retry
 * forever, leaving a live bearer credential in browser storage.
 *
 * The default is RETAIN. Clearing on an unrecognised code would mean a future transient
 * code silently discards a good token from an old build.
 */
export function shouldRetainToken(errorBody) {
  if (!errorBody) return true;
  return errorBody.terminal !== true;
}
